import { render, staticRenderFns } from "./ShowProjectsButton.vue?vue&type=template&id=fdf57a94&"
import script from "./ShowProjectsButton.vue?vue&type=script&lang=js&"
export * from "./ShowProjectsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports